import styled from 'styled-components';
import { Text } from '@make-software/tg-mini-app-ui';

export const Subtitle = styled(Text)(({ theme }) =>
  theme.withMedia({
    color: '#A9AAAD',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '140%',
    fontFamily: 'Inter'
  })
);
